import React, { PureComponent } from 'react';
import { func, objectOf, string } from 'prop-types';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import withReducerSaga from 'yoda-site-components/lib/hoc/ReducerRegistry/withReducerSaga';
import DHTML from 'yoda-site-components/lib/iris/wrappers/DHTML/DHTML';
import { clearAltMessage } from '../../actions/GalleryAction';
import { getAltMessage } from '../../selectors/SearchAltMessage';
import altMessageReducer from '../../reducers/AltMessageReducer';
import { selectAltMessage } from '../../selectors/fromState';
import { setGalleryAltMessageContentWithIris } from '../../actions/GalleryIrisAction';
import { getPageURL } from '../../utils';
import { source, isGalleryURL } from '../../common/constants';

export class GalleryAltMessage extends PureComponent {
    static defaultProps = {
        altMessage: null,
        irisAltMessageFromDhtml: null,
        html: '',
        componentType: '',
        dhtmlType: '',
    };

    static propTypes = {
        actions: objectOf(func).isRequired,
        altMessage: string,
        irisAltMessageFromDhtml: string,
        html: string,
        componentType: string,
        dhtmlType: '',
    };

    constructor(props) {
        super(props);
        this.state = { messageBoxClose: true };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const { actions, irisAltMessageFromDhtml } = this.props;

        actions.setGalleryAltMessageContentWithIris(irisAltMessageFromDhtml);
    }

    oncloseMessage = () => {
        this.setState({ messageBoxClose: false });
    };

    render() {
        const { actions, altMessage, html, componentType, dhtmlType } = this.props;
        const { messageBoxClose } = this.state;
        let alteredMessage =
            componentType === 'dhtml' || componentType === 'dhtmlrte' ? html : altMessage;
        /* istanbul ignore next */
        if (alteredMessage) {
            const sourceUrl = getPageURL();
            const splitUrl = sourceUrl.split('&');
            const sourceUrlFound = splitUrl && splitUrl.find((element) => element.includes(source));
            const words = altMessage.split('"');
            const result = words.filter((element) => element.includes(isGalleryURL));
            if (result && result.length > 0) {
                const issame = result.every((val, i, arr) => val === arr[0]);
                let isRRParam = result[0].includes(sourceUrlFound);
                alteredMessage =
                    issame &&
                    sourceUrlFound &&
                    !isRRParam &&
                    altMessage.replaceAll(result[0], result[0].concat(`&${sourceUrlFound}`));
                if (!issame) {
                    const recursive = (str) => {
                        let strReturn = str;
                        result.forEach((element, index) => {
                            isRRParam = result[index].includes(sourceUrlFound);
                            if (sourceUrlFound && !isRRParam) {
                                strReturn = strReturn.replace(
                                    result[index],
                                    result[index].concat(`&${sourceUrlFound}`)
                                );
                            }
                        });
                        return strReturn;
                    };
                    alteredMessage = recursive(altMessage);
                }
            }
        }
        if (dhtmlType === 'Default') {
            return <DHTML html={html} />;
        }
        const scriptPattern = /(<script(((?!src).)*?>))[^<]*<\/script>/g;
        const containsScript = alteredMessage && alteredMessage.match(scriptPattern);
        if (containsScript && containsScript.length) {
            this.insertScript = containsScript.map(
                (currentScript) => currentScript.replace(/(<|<\/)script[^>]*>/g, ''),
                ''
            );
            alteredMessage = alteredMessage.replace(scriptPattern, '');
        }
        return (
            messageBoxClose &&
            alteredMessage && (
                <div className="relative">
                    <MessageBox
                        className="align-center flex mx-auto my-0 w-5/6 z-10"
                        level="section"
                        onClose={
                            componentType === 'dhtml' || componentType === 'dhtmlrte'
                                ? this.oncloseMessage
                                : actions.clearAltMessage
                        }
                        type="information"
                    >
                        {/* eslint-disable react/no-danger */}
                        <div
                            className="bg-info"
                            data-automation-id="dhtml-content"
                            dangerouslySetInnerHTML={{ __html: alteredMessage }}
                        />
                    </MessageBox>
                </div>
            )
        );
    }
}

const mapStateToProps = (state, props) => ({
    altMessage: selectAltMessage(state),
    irisAltMessageFromDhtml: getAltMessage(state, props),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            clearAltMessage,
            setGalleryAltMessageContentWithIris,
        },
        dispatch
    ),
});

export default compose(
    withReducerSaga([altMessageReducer], []),
    connect(mapStateToProps, mapDispatchToProps)
)(GalleryAltMessage);
